import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Auth0Provider } from '@auth0/auth0-react';
import { BROKER_AUDIENCE } from './constants/api-constants';
import { ToastProvider } from './components/ui/toast';
import { installChunkReloadHandler } from './lib/chunk-reload';
import { initDatadogRum } from './lib/datadog';
import './index.css';

initDatadogRum();
installChunkReloadHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Auth0Provider
    domain={
      import.meta.env.VITE_AUTH0_DOMAIN || 'dev-zattns50vlwxc85q.us.auth0.com'
    }
    clientId={
      import.meta.env.VITE_AUTH0_CLIENT_ID || '5RKxiA1lBmGrTTAvY0vMgx3vUYzITQRR'
    }
    authorizationParams={{
      redirect_uri:
        import.meta.env.VITE_AUTH0_CALLBACK_URL || window.location.origin,
      audience: BROKER_AUDIENCE,
      scope: 'openid profile email offline_access',
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    useRefreshTokensFallback={true}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </PersistGate>
    </Provider>
  </Auth0Provider>,
);
